import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-2xl bg-background-100 ring-1 ring-background-200/70 transition-all duration-300 hover:-translate-y-1 hover:ring-primary-300">
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}封面`}
          title={comic.title}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs text-background-50 ${
            comic.status === '连载中' ? 'bg-primary-500' : 'bg-foreground-700'
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute right-3 top-3 flex h-8 items-center gap-1 rounded-full bg-background-50/90 px-2.5 text-xs font-semibold text-secondary-700">
          <i className="ri-star-fill text-secondary-500" />
          {comic.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="text-base font-semibold text-foreground-950">{comic.title}</h3>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {comic.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800">
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-book-2-line" /> {comic.chapters}话
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" /> {comic.views}
          </span>
        </div>
      </div>
    </article>
  );
}